import { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import {
  Stack, 
  Container
} from '@mui/material';

import SignatureButton from '../components/signature-button';
import OTPInput from '../components/otp-input';
import TokenChallenge, { useTokenChallenge } from '../components/token-challenge';
import { EntityContext } from '../entity';

function SignatureConfirmationPage() {

    const { signerKey } = useParams();
    const { requestSignatureToken, getSignatureTokenState } = useContext(EntityContext);

    const [otp, setOtp] = useState('');
    const { onSignError, ...challenge } = useTokenChallenge(
      () => requestSignatureToken({ envelope_signer_key: signerKey }),
      () => getSignatureTokenState(signerKey)
    );

  return (
    <>
    
      <Helmet>
          <title> Confirmar Assinatura </title>
      </Helmet>

      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 }, py: { xs: 4, sm: 6 } }}>

        <Stack 
          alignItems="center" 
          justifyContent="center" 
          spacing={{ xs: 3, sm: 4, md: 5 }}
          sx={{ 
            minHeight: { xs: 'calc(100vh - 200px)', sm: 'auto' },
            py: { xs: 4, sm: 6, md: 12 }
          }}
        >
            <TokenChallenge {...challenge}>
              <OTPInput value={otp} onChange={setOtp} length={6} />
              <SignatureButton otp={otp} signerKey={signerKey} onError={onSignError}/>
            </TokenChallenge>
        </Stack>
        </Container>
  </> 
  );
}

export default SignatureConfirmationPage;
